import type { InsightCardData } from "../types";

export function InsightCard({ data }: { data: InsightCardData }) {
	return (
		<div className="group border-gold/10 bg-dark-accent hover:border-gold/30 z-10 overflow-hidden border p-6 transition-all duration-500">
			<div className="mb-4 flex items-center gap-2">
				<span className="material-symbols-outlined text-gold text-[14px]">
					{data.icon}
				</span>
				<span className="text-gold text-[10px] tracking-widest uppercase">
					{data.category}
				</span>
			</div>
			<p className="text-ivory/70 mb-4 text-sm leading-relaxed font-light">
				{data.text}
			</p>
			{data.attribution && (
				<div className="text-ivory/30 text-[10px] tracking-tighter uppercase">
					{data.attribution}
				</div>
			)}
		</div>
	);
}
